<div
  *ngIf="clientSupport?.contactInfo || (clientSupport?.userManual && isAppOnline)"
  class="clientSupport"
  [matMenuTriggerFor]="clientSupportMenu"
>
  <button data-testId="client-support" mat-icon-button class="mr-2 button--square button--small">
    <mat-icon class="icon--large" svgIcon="lifebuoy"></mat-icon>
  </button>
  <mat-menu #clientSupportMenu="matMenu" class="m-2 clientSupportMenu" xPosition="before">
    <ng-template matMenuContent>
      <button
        mat-menu-item
        data-testId="contact-info"
        class="clientSupportMenu_item"
        *ngIf="clientSupport?.contactInfo"
        (click)="openContactInfo()"
      >
        <mat-icon svgIcon="card-account-details-outline"></mat-icon>
        <span i18n="@@shared.clientSupport.btnContactInfo">Contact Info</span>
      </button>
      <button
        mat-menu-item
        data-testId="user-manual"
        class="clientSupportMenu_item"
        *ngIf="clientSupport?.userManual && isAppOnline"
        (click)="downloadUserManual()"
      >
        <mat-icon svgIcon="cloud-download-outline"></mat-icon>
        <span i18n="@@shared.clientSupport.btnUserManual">User Manual</span>
      </button>
    </ng-template>
  </mat-menu>
</div>
